import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import "./RolesComponent.css";
import { Button } from "react-bootstrap";
import Select from "react-select";


const RolesComponent = ({ userDataWithIds, getRowId, columns, handleSave , biList, setBiId}) => {

  const [selectedBI, setSelectedBI] = useState(null);

  useEffect(() => {
    const storedBI = localStorage.getItem("bi_id");
    if (storedBI) {
      setSelectedBI(storedBI);
    }
  }, []);

  const handleBIChange = (selectedOption) => {
  const value = selectedOption ? selectedOption.value : null;

  setSelectedBI(value);
  localStorage.setItem("bi_id", value);
  setBiId(value);
};
  if (!localStorage.getItem("authenticated")) {
    return (
      <div>
        <a href="/logout">Login Again</a>
      </div>
    );
  } else {
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
        }}
      >
        <div style={{ marginBottom: "60px" }}>
          <div
            style={{
              textAlign: "left",
              paddingTop: "10px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              <div
                style={{
                  marginTop: "10px",
                  fontSize: "var(--main-heading)",
                  fontWeight: "var(--heading-font-weight)",
                }}
              >
                Role Management
              </div>
              <br />
              <span style={{ fontWeight: 400, fontSize: "15px" }}>
                Permissions - R: Read, &nbsp; W: Write, &nbsp; A: Administrator,
                &nbsp; N: None
              </span>
            </div>
            <div style={{ textAlign: "right" }}>
              <Button
                type="button"
                style={{
                  cursor: "pointer",
                  backgroundColor: "#0A5F59",
                  text: "center",
                  padding: "10px 35px",
                  border: "1px solid var(--rs-border-primary)",
                  position: "static",
                }}
                onClick={() => handleSave()}
              >
                Save
              </Button>
            </div>
          </div>

          <div style={{width:'400px', margin:'20px 0'}} >
            <Select
              isSearchable
              className="status-select bi"
              // styles={customStyles}
              placeholder="Select BI"
              options={biList}
              value={biList.find((option) => option.value === selectedBI)}
              onChange={handleBIChange}
              getOptionLabel={(e) => (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={{ marginLeft: 5 }}>{e.label}</span>
                </div>
              )}
              filterOption={(option, inputValue) => {
                const label = String(option.data.label || "").toLowerCase();
                const search = inputValue.toLowerCase();
                return label.includes(search);
              }}
            />
          </div>

          <DataGrid
            style={{
              fontFamily: "Source Sans Pro",
              fontSize: "var(--sub-heading-font-size)",
              height: "75vh",
            }}
            rows={userDataWithIds}
            getRowId={getRowId}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 100,
                },
              },
            }}
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
              },
            }}
            checkboxSelection
            disableColumnSelector
            disableDensitySelector
            disableRowSelectionOnClick
          />
        </div>
      </div>
    );
  }
};

export default RolesComponent;
